<div class='dfam-browse' data-flex-gt-sm="60" offset-gt-sm="15">
  <div>
    <h3>Browse Entries <dfam-help-icon link="/help/browse" [tooltip]="help.browse"></dfam-help-icon></h3>
    <mat-divider></mat-divider>

    <dfam-browse-panel [repository]="repository"></dfam-browse-panel>

  </div>
</div>
